module.exports = __webpack_public_path__ + "static/media/client_detail_img3.1d7479f7.jpg";